import React from 'react';
import { Prompt, useHistory } from 'react-router-dom';
import { Button, Divider } from '@material-ui/core';

import { HeaderDropDown } from 'components/HeaderDropDown';

import { Settings } from './components/Settings';
import { Activities } from './components/Activities';
import { DataEntryTableGroup } from './components/DataEntryTableGroup';
import { EeModal } from 'components/EeModal/EeModal';

import { useDataEntryPage } from './useDataEntryPage'

export const DataEntryPage = () => {
  const history = useHistory();
  const logic = useDataEntryPage();

  return (
    <div className="bg-gray w-100 mx-auto px-3" style={{ maxWidth: 1200 }}>
      <div className="d-flex justify-content-between align-items-center my-3">
        {logic.models.company && (
          <HeaderDropDown
            items={
              logic.models.companies?.map(({ id, name }) => ({ id, name })) || []
            }
            value={logic.models.company?.id || '-1'}
            // @ts-ignore
            disabled={logic.editable || logic.settingsEditable}
            onChange={(event: any) => {
              const fId = event.target.value;
              history.push(`/kpis/data-entry/${fId}`);
            }}
          />
        )}
      </div>

      <div
        hidden={logic.noTemplate}
        className="d-flex justify-content-between align-items-end my-3"
      >
        <div>
          {/* Last published */}
          <span
            className="fs-14"
            style={{ color: '#333333', display: 'block' }}
            hidden={logic.noTemplate || !logic.lastPublished.date}
          >
            Last Published{' '}
            {logic.lastPublished.user &&
              `by ${logic.lastPublished.user.firstName} ${logic.lastPublished.user.lastName} `}
            {logic.lastPublished.date?.format('LLLL')}
          </span>

          {/* Last draft saved */}
          <span
            className="fs-14"
            style={{ color: '#333333', display: 'block' }}
            hidden={
              logic.noTemplate ||
              !logic.lastTopLeftDraft ||
              !logic.lastTopLeftDraft.date ||
              (logic.lastPublished.date && logic.lastTopLeftDraft.date < logic.lastPublished.date)
            }
          >
            Last Draft Saved by {logic.lastTopLeftDraft?.user?.firstName}{' '}
            {logic.lastTopLeftDraft?.user?.lastName}{' '}
            {logic.lastTopLeftDraft?.date?.format('LLLL')}
          </span>
        </div>

        <EeModal
          open={logic.cancelConfirmIsOpen}
          title={'Exit Data Table Editor'}
          submitTitle="Exit without saving"
          onClose={() => logic.setCancelConfirmIsOpen(false)}
          onSubmit={() => {
            logic.setCancelConfirmIsOpen(false);
            logic.cancelChanges(logic.cancelDataGridChanges).then();
          }}
        >
          <p>{logic.cancelConfirmationMsg}</p>
        </EeModal>

        <div hidden={logic.editable}>
          <Button
            ref={logic.editButton}
            color="primary"
            variant="contained"
            onClick={logic.startEdit}
          >
            Edit
          </Button>
        </div>

        <Prompt when={logic.editable} message={logic.cancelConfirmationMsg} />

        <div hidden={!logic.editable}>
          <Button
            variant="outlined"
            onClick={() => logic.cancelChangesClick()}
            disabled={logic.models.isLoading}
          >
            Close
          </Button>
          <Button
            className="mx-3"
            color="primary"
            variant="contained"
            disabled={!logic.models.hasUnsavedChanges || logic.models.isLoading}
            onClick={async () => {
              await logic.operations.updateData();
              await logic.operations.loadCompany(logic.companyId);
              logic.addSnackbar(
                `Draft Saved: ${logic.models.company?.name} data was successfully saved.`,
              );
            }}
          >
            Save Draft
          </Button>
          <Button
            color="primary"
            variant="contained"
            disabled={logic.models.hasUnsavedChanges}
            onClick={() => logic.setPublishConfirmIsOpen(true)}
          >
            Publish
          </Button>
        </div>
      </div>

      <EeModal
        open={logic.publishConfirmIsOpen}
        title={`Publish Data - ${logic.models.company?.name}`}
        submitTitle="Publish"
        onClose={() => logic.setPublishConfirmIsOpen(false)}
        onSubmit={() => {
          logic.setPublishConfirmIsOpen(false);
          logic.publishChanges().then(() => logic.operations.loadCompany(logic.companyId));
        }}
      >
        <p>
          Publishing this data will update the view within this KPI module as
          well
        </p>
        <p>
          as the Metrics displayed on the bottom of this Company's Dashboard
          page.
        </p>
        <p>Are you sure you want to Publish?</p>
      </EeModal>

      <Divider />

      <div
        hidden={!logic.noTemplate || !logic.models.company}
        className="text-center p-1"
        style={{ backgroundColor: 'white', height: 730 }}
      >
        <div className="my-5">
          <div>There is no Template assigned to this Company. </div>
          <div>To view and edit data for KPIs, please assign a Template </div>
          <div>to the Company at Status Page.</div>
        </div>

        <Button
          color="primary"
          variant="contained"
          onClick={() => history.push(`/kpis/company`)}
        >
          Go to Status page
        </Button>
      </div>

      <div
        hidden={logic.models.companies == null || logic.models.companies.length > 0}
        className="text-center p-1"
        style={{ backgroundColor: 'white', height: 730 }}
      >
        <div className="my-5">
          <div>There is no Company yet. </div>
        </div>
      </div>

      <div
        hidden={logic.noTemplate}
        className="p-4"
        style={{ backgroundColor: 'white' }}
      >
        {logic.models.kpiGroups
          ?.sort((a: any, b: any) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()))
          .map((kpiGroup: any, index: number) => (
            <DataEntryTableGroup
              key={index}
              groupRows={logic.rows[kpiGroup.name]}
              columns={logic.columns}
              editable={logic.editable}
              kpiGroup={kpiGroup}
              isLoading={logic.models.isLoading}
              onGridRowEdit={logic.onGridRowEdit}
              // @ts-ignore
              scrolledOnceGrid={logic.scrolledOnce[kpiGroup.name]}
              onScrolledOnce={() =>
                logic.setScrolledOnce({ ...logic.scrolledOnce, [kpiGroup.name]: true })
              }
            />
          ))
        }
      </div>

      <div hidden={logic.noTemplate} className="d-flex pt-5">
        <Activities activities={logic.activities} />
        <Settings
          models={logic.models}
          operations={logic.operations}
          editable={logic.editable}
          onSettingsEditable={(value: boolean) => logic.setSettingsEditable(value)}
          // @ts-ignore
          settingsEditable={logic.settingsEditable}
        />
      </div>
    </div>
  );
};
